module.exports = __webpack_public_path__ + "static/PoweredgeServers-0b965124485b0f8ea169092429a8c7c3.png";